import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { orchestrator } from 'satcheljs';
import { SaveCalendarViewConfig, lazyDeleteSavedCalendarView } from 'owa-save-calendar-view-data';
import { showDeleteSavedViewDialog } from '../actions/publicActions';
import {
    deleteSaveViewDialogTitle,
    deleteSaveViewDialogSubtext,
    deleteSaveViewDialogConfirm,
} from '../components/SaveViewDialog.locstring.json';
import loc, { format } from 'owa-localize';

orchestrator(showDeleteSavedViewDialog, actionMessage => {
    showDeleteSavedViewDialogOrchestrator(actionMessage.saveCalendarViewConfig);
});

async function showDeleteSavedViewDialogOrchestrator(
    saveCalendarViewConfig: SaveCalendarViewConfig
) {
    const response: DialogResponse = await confirmSavedViewDelete(saveCalendarViewConfig);
    if (response === DialogResponse.ok) {
        lazyDeleteSavedCalendarView.importAndExecute(saveCalendarViewConfig.id);
    }
}

function confirmSavedViewDelete(
    saveCalendarViewConfig: SaveCalendarViewConfig
): Promise<DialogResponse> {
    return confirm(
        loc(deleteSaveViewDialogTitle),
        format(loc(deleteSaveViewDialogSubtext), saveCalendarViewConfig.viewName),
        false,
        {
            okText: loc(deleteSaveViewDialogConfirm),
        }
    );
}
